import { omit } from 'lodash'
import { create } from 'zustand'

import { UnmatchedUpload } from '__generated__/atlas-types'

import { ProductImage, StyleColor } from '../manageImagesModal.types'
import {
  setCurrentPage,
  setHasStyleColorChanges,
  setIsRemovingImages,
  setIsSavingImages,
  setIsStyleDataLoading,
  setIsUploadingImages,
  setLastPage,
  setLinesheetId,
  setProductId,
  setProductImages,
  setProductImagesBak,
  setSearch,
  setSelectedImages,
  setStyleColors,
  setUploadProgress,
} from './useManageImagesStore.actions'
import { ManageImagesState } from './useManageImagesStore.types'

export const initialState = {
  currentPage: 1,
  hasStyleColorChanges: false,
  isRemovingImages: false,
  isSavingImages: false,
  isUploadingImages: false,
  lastPage: 1,
  linesheetId: '',
  productId: '',
  productImages: [] as ProductImage[],
  productImagesBak: [] as ProductImage[],
  search: '',
  selectedImages: new Map<string, UnmatchedUpload>(),
  styleColors: [] as StyleColor[],
  uploadProgress: 0,
  isStyleDataLoading: false,
}

const useManageImagesStore = create<ManageImagesState>((set) => ({
  ...initialState,
  setCurrentPage: ({ currentPage }) => setCurrentPage({ currentPage, set }),
  setHasStyleColorChanges: ({ hasStyleColorChanges }) =>
    setHasStyleColorChanges({ hasStyleColorChanges, set }),
  setIsRemovingImages: ({ isRemovingImages }) =>
    setIsRemovingImages({ isRemovingImages, set }),
  setIsSavingImages: ({ isSavingImages }) =>
    setIsSavingImages({ isSavingImages, set }),
  setIsUploadingImages: ({ isUploadingImages }) =>
    setIsUploadingImages({ isUploadingImages, set }),
  setLastPage: ({ lastPage }) => setLastPage({ lastPage, set }),
  setLinesheetId: ({ linesheetId }) => setLinesheetId({ linesheetId, set }),
  setProductId: ({ productId }) => setProductId({ productId, set }),
  setProductImages: ({ productImages }) =>
    setProductImages({ productImages, set }),
  setProductImagesBak: ({ productImagesBak }) =>
    setProductImagesBak({ productImagesBak, set }),
  setSearch: ({ search }) => setSearch({ search, set }),
  setSelectedImages: ({ selectedImages }) =>
    setSelectedImages({ selectedImages, set }),
  setStyleColors: ({ styleColors }) => setStyleColors({ styleColors, set }),
  setUploadProgress: ({ uploadProgress }) =>
    setUploadProgress({ uploadProgress, set }),
  setIsStyleDataLoading: ({ isStyleDataLoading }) =>
    setIsStyleDataLoading({ isStyleDataLoading, set }),
  softResetStore: () => set(omit(initialState, ['linesheetId', 'productId'])),
  hardResetStore: () => set(initialState),
}))

export default useManageImagesStore
